import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { defineMessages, useIntl } from 'react-intl'

// Actions
import { setFilter } from 'src/actions/filters'
// Selectors
import { selectFilter } from 'src/store/selectors/filters'
// Styles
import styles from './ListingsSort.module.scss'

const LISTINGS_SORT_SELECT = defineMessages({
  daysOnMarket: {
    id: 'HomeSearch.listings.order.daysOnMarket',
    defaultMessage: 'Newest listings',
  },
  priceOptionLowest: {
    id: 'HomeSearch.listings.order.lowest',
    defaultMessage: 'Lowest price',
  },
  priceOptionHighest: {
    id: 'HomeSearch.listings.order.highest',
    defaultMessage: 'Highest price',
  },
  squareFeetOptionSmallest: {
    id: 'HomeSearch.listings.order.smallest',
    defaultMessage: 'Smallest sq. ft.',
  },
  squareFeetOptionLargest: {
    id: 'HomeSearch.listings.order.largest',
    defaultMessage: 'Largest sq. ft.',
  },
})

const ListingsSort = () => {
  const dispatch = useDispatch()
  const filter = useSelector(selectFilter)
  const intl = useIntl()
  const [sortValue, setSortValue] = useState('')

  const onChange = event => {
    const [key, val] = event.target.value.split(', ')
    const sortFilters = { order: { [key]: val }, page: 1 }
    dispatch(setFilter({ ...sortFilters }))
  }

  useEffect(() => {
    if (filter?.order) {
      const sortKey = Object.keys(filter.order)[0]
      setSortValue(`${sortKey}, ${filter.order[sortKey]}`)
    }
  }, [filter])

  return (
    <select
      onChange={event => onChange(event)}
      className={styles.listingsSort}
      data-qa='listingsSort'
      value={sortValue}
    >
      <option value='days_on_market, asc'>
        {intl.formatMessage(LISTINGS_SORT_SELECT.daysOnMarket)}
      </option>
      <option value='price_cents, asc'>
        {intl.formatMessage(LISTINGS_SORT_SELECT.priceOptionLowest)}
      </option>
      <option value='price_cents, desc'>
        {intl.formatMessage(LISTINGS_SORT_SELECT.priceOptionHighest)}
      </option>
      <option value='sqft_total, asc'>
        {intl.formatMessage(LISTINGS_SORT_SELECT.squareFeetOptionSmallest)}
      </option>
      <option value='sqft_total, desc'>
        {intl.formatMessage(LISTINGS_SORT_SELECT.squareFeetOptionLargest)}
      </option>
    </select>
  )
}

export default ListingsSort
